import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M12 6v.913a.5.5 0 0 0 .825.38l2.232-1.913a.5.5 0 0 0 0-.76l-2.232-1.912a.5.5 0 0 0-.825.38V4a8 8 0 1 0 6.472 3.298 1 1 0 1 0-1.618 1.175A6 6 0 1 1 12 6"
    }
  )
);
var SvgRefreshOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var RefreshOutlined_default = SvgRefreshOutlined;

export { RefreshOutlined_default as default };
